// extracted by mini-css-extract-plugin
export default {"HorizontalStack":"Advertising1Section_HorizontalStack__5bq9S","Li":"Advertising1Section_Li__Bi69T"};